export default {
  userDepartments: state => state.userDepartments,
  userDepartmentInfos: state => state.userDepartmentInfos
}
